import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from './router/index';
import store from './store/index';
import Uploader from '@forzoom/uploader';
import { MobileButton } from '@forzoom/mobile-button';
// import jssdk from '@forzoom/jssdk';
import jssdk from '@/lib/script/jssdk';
import {
    Popup,
} from '@forzoom/popup';
import Touch from '@forzoom/touch';
import VueSkeleton from '@/lib/vue/plugins/skeleton/index'; // 暂时不知道是什么
import VueLazyload from 'vue-lazyload';
import Thumbnail from '@forzoom/thumbnail';
import VueRouteScroll from '@forzoom/vue-router-scroll';
import ScrollListener from '@forzoom/scroll-listener';
import { ItemTitle, ItemInput, ItemSelect, ItemCascader, ItemList, ItemButtonGroup, ItemUploader, ItemTextarea, ItemMultiUploader, ItemCommonUploader } from '@forzoom/item-form';
import { CompactInput, CompactSelect, CompactCascader, CompactTextarea } from '@forzoom/compact-form';
import mock from '@/mocks/index';
import './main.less';
import {
    Swipe,
    SwipeItem,
    DatetimePicker,
    Tabs,
    Tab,
    CountDown,
    PullRefresh,
    Sticky,
    Calendar,
    Dialog,
    Circle,
    Picker,
    Popup as VantPopup,
    Toast,
    Collapse,
    CollapseItem,
    Icon,
    Field,
    List,
    NoticeBar,
    Cell,
    Overlay,
    Search,
    Empty,
    Lazyload,
    Tag,
    ActionSheet,
    Button,
    CellGroup,
    DropdownItem,
    DropdownMenu,
    Popover,
    Row,
    Col,
    Checkbox,
    RadioGroup,
    Radio
} from 'vant';
import 'lib-flexible';
import 'normalize.css';
// 引入装饰器
import { Component } from 'vue-property-decorator';
// 错误捕获
import './lib/service/sentry';
import VConsole from 'vconsole';
import extendVue from '@/lib/vue/extend';

window.apiUrl = process.env.RO_API_URL;
window.pageUrl = process.env.RO_PAGE_URL;
window.appPageRoot = process.env.RO_APP_PAGE_ROOT;

function report(type: string, id: string) {
    if (type === 'page') {
        if (id === ROUTE_NAME.ACTIVITY_SUBMIT_ORDER) {
            const srctag = getQS().srctag as string;
            const map: { [srctag: string]: string } = {
                'invite_card_common-20200927-01': MTA.ID_FUNNEL_14_INVITE_CARD_1,
                'invite_card_common-20200927-02': MTA.ID_FUNNEL_14_INVITE_CARD_2,
                'invite_card_common-20200927-03': MTA.ID_FUNNEL_14_INVITE_CARD_3,
                'invite_card_common-20200927-04': MTA.ID_FUNNEL_14_INVITE_CARD_4,
                'invite_card_new-common-20200927-01': MTA.ID_FUNNEL_14_INVITE_CARD_5,
                'invite_card_new-common-20201015-01': MTA.ID_FUNNEL_14_INVITE_CARD_6,
                'invite_card_team-0913-01': MTA.ID_FUNNEL_14_TEAM_INVITE_CARD_1,
                'invite_card_team-0913-02': MTA.ID_FUNNEL_14_TEAM_INVITE_CARD_2,
                'invite_card_new-team-20200927-01': MTA.ID_FUNNEL_14_TEAM_INVITE_CARD_3,
                'monitor_invite_card': MTA.ID_FUNNEL_MONITOR_INVITE_CARD_JOIN,
                'cansai4': MTA.ID_FUNNEL_NUMBER_CLOTH,
                'jmsxy': MTA.ID_FUNNEL_14_JMSXY,
                'tesla': MTA.ID_FUNNEL_14_TESLA,
            };
            if (map[srctag]) {
                clickStat(map[srctag], {
                    enter: true,
                });

                const ev: PushEvent = [
                    '_trackEvent',
                    `page`, // 进入页面
                    id,
                    srctag,
                ];
                _czc.push(ev);
                aplus_queue.push({
                    action: 'aplus.record',
                    arguments: [
                        '_trackEvent',
                        'CLK',
                        {
                            pagename: `page_${ROUTE_NAME.ACTIVITY_SUBMIT_ORDER}`,
                            id,
                            srctag,
                        },
                    ],
                });
            }
            clickStat(MTA.ID_FUNNEL_JOIN_GENERAL, { enter: true });
        }
    }
}

// 注册钩子
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
    'beforeRouteLeave',
]);
// 全局混入
Vue.mixin({
    created() {
        report('page', router.currentRoute.name!);
    },
    beforeRouteLeave(to: Route, from: Route, next: (to?: any) => any) {
        if (to.meta && !to.meta.disableShare) {
            // 分享
            enableShareHook(from);
        }

        // 关闭popup
        const popup = pop();
        if (popup) {
            next(false);
            return;
        }

        next();
    },
});

// 引入工具
import {
    getQS,
    imageFilter,
} from '@/lib/utils';
import { enableShareHook } from './router/hook';
import { Route } from 'vue-router';
// 提示框
import { del, set } from './lib/service/storage';
import { KEY_AUTH_TOKEN, KEY_LOGINUP, loginFn, ROUTE_NAME } from './lib/constant';
import { pop } from './lib/script/popup';
import { clickStat } from '@forzoom/mta';
import MTA from './lib/mta';

// 全局混入
Vue.mixin({
    mounted() {
        if (history && history.length) {
            store.commit('setHistoryLength', history.length);
        }
    },
});

// 全局注册组件
Vue.component('MobileButton', MobileButton);

Vue.component('Popup', Popup);
Vue.component('MyPopup', Popup);
Vue.component('Touch', Touch);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Tabs.name, Tabs);
Vue.component(Tab.name, Tab);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Cell.name, Cell);
Vue.component(Overlay.name, Overlay);
Vue.component(CountDown.name, CountDown);
Vue.component(PullRefresh.name, PullRefresh);
Vue.component(Sticky.name, Sticky);
Vue.component(Calendar.name, Calendar);
Vue.component(Dialog.Component.name, Dialog.Component);
Vue.component(Circle.name, Circle);
Vue.component(VantPopup.name, VantPopup);
Vue.component(Search.name, Search);
Vue.component(Empty.name, Empty);
Vue.component(Tag.name, Tag);
Vue.component(ActionSheet.name, ActionSheet);
Vue.component(Button.name, Button);
Vue.component(CellGroup.name, CellGroup);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(Checkbox.name, Checkbox);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Radio.name, Radio);
Vue.component(Popover.name, Popover);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);


const components = [
    ItemTitle,
    ItemInput,
    ItemSelect,
    ItemCascader,
    ItemList,
    ItemButtonGroup,
    ItemUploader,
    ItemTextarea,
    ItemMultiUploader,
    ItemCommonUploader,
    CompactInput,
    CompactSelect,
    CompactCascader,
    CompactTextarea,
];

for (let i = 0, len = components.length; i < len; i++) {
    const component = components[i];
    Vue.component(component.name!, component);
}

extendVue();

// 创建axios实例
const axiosInstance = axios.create({
    // 设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
    baseURL: window.apiUrl,
    // 表示跨域请求时是否需要使用凭证
    withCredentials: true,
    // 超时时间
    timeout: 30000,
    // 有效状态码
    validateStatus(status) {
        return status >= 200 && status < 500;
    },
});
// 响应拦截器
axiosInstance.interceptors.response.use((response) => {
    // 发生401
    if (response.status === 401) {
        del(KEY_AUTH_TOKEN);
        // const hasLogin = store.state.auth.hasLogin;
        // 可以用是否登录来对游客状态和登陆失效对应不同的提示👆
        Dialog.confirm({
            title: '重新登录提示',
            message: '当前处于游客模式，需要登录。',
            confirmButtonText: '立即登录',
        }).then(async () => {
            const rdata = await loginFn();
            const status = rdata?.status;
            const name = rdata?.name;
            if (status === 0) {
                name && location.replace(name);
            } else if (status === 1) {
                location.replace(name);
            }
        });
        // location.reload();
    }
    return response;
}, (error) => {
    // 连接超时响应
    const message = error.message as string;
    if (message && message.indexOf('timeout') >= 0) {
        store.commit('startError', {
            type: 'icon',
            icon: '&#xe613;',
            text: '当前网络环境较差',
        });
    }
    return Promise.reject(error);
});
// 同步获取服务器时间
axiosInstance.interceptors.response.use(function syncServerTime(response) {
    if (response && response.data && response.data.timestamp) {
        store.commit('setServerTimestamp', response.data.timestamp);
    }
    return response;
});
// 使用插件
Vue.use(VueAxios, axiosInstance);
Vue.use(Uploader, {
    transformWXLocalImageData: true,
});
Vue.use(jssdk, {
    store,
});
Vue.use(VueSkeleton);
Vue.use(VueLazyload, {
    filter: imageFilter,
});
Vue.use(ScrollListener, {
    store,
});
Vue.use(Thumbnail, {
    imageFilter,
    enterClass: 'image-blur1',
    leaveClass: 'image-blur2',
});
Vue.use(VueRouteScroll, {
    router,
});
Vue.use(Picker);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Icon);
Vue.use(Field);
Vue.use(List);
Vue.use(NoticeBar);
Vue.use(Lazyload);

// 非生产环境，使用mock数据
if (process.env.NODE_ENV !== 'production') {
    mock();
}
if (process.env.RO_ENV === 'development') {
    new VConsole();
}
// 阻止启动生产消息（常用作指令）
Vue.config.productionTip = false;
Vue.config.keyCodes = {
    enter: 13,
};

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
